<script>
	import model from "../../stores/modelStore";
	import confirmationPages from "./confirmationPages";
	import { projectSettings } from "../../config";
	import FormRow from "../../components/FormRow.svelte";
	import FormColumn from "../../components/FormColumn.svelte";
	import ReviewSectionHeader from "../../components/ReviewSectionHeader.svelte";

	let disabled = true;
	let medicalAuthority = false;

	document.title = `${projectSettings.classActionName} - Review`;

	// Extract query parameter from URL
	if (typeof window !== "undefined") {
		const urlParams = new URLSearchParams(window.location.search);
		medicalAuthority = urlParams.get("medicalAuthority") === "true";
	}

	const name = $model.FirstName + " " + $model.Surname;
	const dob = $model.DateOfBirth;
	const address = $model.FormattedAddress;
	const state = $model.State;
	const dateCreated = $model.DateCreated;
</script>

<section>
	{#if medicalAuthority}
		<FormRow class="justify-content-center">
			<FormColumn>
				<h1 class="text-center">Medical Authority</h1>
			</FormColumn>
		</FormRow>
		<!-- <p>
			It is likely that at some stage in the investigation that Shine will need to verify your diagnosis by
			reviewing your medical records, including your pathology and radiology reports. Although the proceeding is
			still in the investigation stage, by completing this consent form to access your medical records now, you
			will be assisting Shine with their investigation. No part of your medical records will be disclosed by Shine
			Lawyers or used without your consent.
		</p> -->
		<p class="greyBox">
			I, <b
				>{name}
				{dob}</b>
			of <b>{address}</b> in the State of <b>{state}</b>, HEREBY AUTHORISE AND DIRECT you to give my lawyers,
			Shine Lawyers, of Level 4, 277 William Street, Melbourne in the State of Victoria any information and
			documentation they may require of you in connection with my matter.
		</p>

		<p>Authorised on: {dateCreated}</p>
	{:else}
		<FormRow class="justify-content-center">
			<FormColumn>
				<h1 class="text-center">{@html projectSettings.classActionName}</h1>
			</FormColumn>
		</FormRow>

		<div class="confirmation">
			{#each confirmationPages as page}
				{#if (typeof page.hidePage === "function" && !page.hidePage($model)) || !page.hidePage}
					<ReviewSectionHeader
						heading={typeof page.confirmationHeading === "function"
							? page.confirmationHeading($model)
							: page.confirmationHeading}></ReviewSectionHeader>

					<svelte:component this={page.component} {...page} {disabled} />
				{/if}
			{/each}

			<FormRow>
				<p>
					By registering with us, you are signing up to receive updates on our investigation into a potential
					class action regarding Social Media. Registering with us does not establish a solicitor client legal
					relationship with Shine Lawyers. No court proceedings have been filed and we may ultimately after
					investigations have concluded decide not to proceed with the case. As we have not entered into a
					solicitor client retainer with you at this time any rights you may have are not presently protected.
					Statutory time limits may also apply to your claim. If you have any concerns about your potential
					claim, please seek independent legal advice immediately.
				</p>
			</FormRow>
		</div>
	{/if}
</section>

<style>
	.greyBox {
		background-color: lightgray;
		padding: 10px;
		margin: 10px 0;
		border-radius: 5px;
		border: 2px solid #ccc;
	}
</style>
